module.exports = __webpack_public_path__ + "static/media/mastodon.3e82a767.svg";